import { getYear } from './getYear/getYear';
import { getMediumDate } from './getMediumDate/getMediumDate';
import { getLongTime } from './getLongTime/getLongTime';
import { getShortDate } from './getShortDate/getShortDate';
import { getShortTime } from './getShortTime/getShortTime';
export const dateTimeFormat = {
    getShortDate,
    getMediumDate,
    getShortTime,
    getLongTime,
    getYear,
};
//# sourceMappingURL=dateTimeFormat.js.map